"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACTOR_WEIGHTS = exports.SPECIES_PROFILES = void 0;
// Deprecated: Use AI_PROFILES from models/Species.ts instead
// This is kept for backward compatibility with backend code
exports.SPECIES_PROFILES = {
    pike: {
        label: 'Pike',
        tempOpt: 12,
        tempSigma: 6,
        dawnBoost: 1.0,
        duskBoost: 1.0,
        nightBoost: 0.3,
        middayPenalty: 0.7,
        windGoodRange: [2, 7],
        windTooMuch: 12,
        moonWeight: 0.3,
        pressureWeight: 1.0
    },
    perch: {
        label: 'Perch',
        tempOpt: 17,
        tempSigma: 5,
        dawnBoost: 0.9,
        duskBoost: 0.9,
        nightBoost: 0.3,
        middayPenalty: 0.85,
        windGoodRange: [1.5, 5],
        windTooMuch: 10,
        moonWeight: 0.5,
        pressureWeight: 0.8
    },
    zander: {
        label: 'Zander',
        tempOpt: 16,
        tempSigma: 5,
        dawnBoost: 1.2,
        duskBoost: 1.25,
        nightBoost: 1.15,
        middayPenalty: 0.6,
        windGoodRange: [1, 4],
        windTooMuch: 8,
        moonWeight: 0.8,
        pressureWeight: 0.9
    },
    general: {
        label: 'General',
        tempOpt: 14,
        tempSigma: 7,
        dawnBoost: 1.0,
        duskBoost: 1.0,
        nightBoost: 0.4,
        middayPenalty: 0.8,
        windGoodRange: [2, 6],
        windTooMuch: 11,
        moonWeight: 0.5,
        pressureWeight: 0.9
    }
};
// Factor weights for fishing score calculation
exports.FACTOR_WEIGHTS = {
    light: 2.0,
    waterTemp: 1.6,
    pressure: 1.6,
    stability: 1.2,
    wind: 1.0,
    precipCloud: 1.0,
    moon: 0.6,
    season: 1.0
};
